import React from 'react'
import { getImages } from '../../components/Common/const'
import ManageTeamItem from '../../components/Admin/ManageTeam/ManageTeamItem'


const ManageTeam = () => {
  return (
    <>
        <div className='container'>
            <div className='ad-black-box'>
                {/* <div className='d-flex align-items-center justify-content-between mb-5'>
                    <div className='md-title font-1-8em text-uppercase'>Manage Team</div>
                    <div className='d-flex align-items-center'>
                        <button type='button' className='theme-sm-btn ad-md-btn text-uppercase me-4'><img src={getImages('admin/plus-icon.svg')}/> Add Employee</button>
                        <div className='ad-search-block d-flex align-items-center'>
                            <input type='text' className='form-control' placeholder='Search'/>
                            <button className='ad-search-btn'>Search</button>
                        </div>
                    </div>
                </div>
                <div className='custom-form ad-custom-form'> */}
                    {/* <div className='ad-team-item'>
                        <div className='row align-items-center'>
                            <div className='col-md-2'>
                                <div className='ad-team-circle'>
                                    <img src={getImages('team/Nathan-Ardizzoni.png')} alt='Nathan Ardizzoni'/>
                                </div>
                                <div className='text-center mt-3'>
                                    <button type='button' className='ad-upload-photo'>Upload Photo</button>
                                </div>
                            </div>
                            <div className='col-md-8'>
                                <div className='row'>
                                    <div className='col-md-4 mb-3'>
                                        <div className='cs-label'>Full Name</div>
                                        <input type='text' className='form-control'/>
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <div className='cs-label'>Position</div>
                                        <input type='text' className='form-control'/>
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <div className='cs-label'>Phone</div>
                                        <input type='text' className='form-control'/>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='cs-label'>Email</div>
                                        <input type='text' className='form-control'/>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='cs-label'>Location</div>
                                        <select className='form-control'>
                                            <option>Austin</option>
                                            <option>Boerne</option>
                                        </select>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='cs-label'>Department</div>
                                        <select className='form-control'>
                                            <option>Leadership</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-2 text-center'>
                                <button
                                    type="button"
                                    className="ad-trans-btn xs-title fw-400 font-15"
                                >
                                    <img className="mb-1" src={getImages('admin/trash-icon.svg')} alt="delete" />
                                    <div>Delete</div>
                                </button>
                            </div>
                        </div>
                    </div> */}
                    <ManageTeamItem />
                {/* </div> */}
            </div>
        </div>
    </>
  )
}

export default ManageTeam